export const BACKEND_URL = process.env.VUE_APP_BACKEND_URL ? process.env.VUE_APP_BACKEND_URL: "";